import { useState } from 'react';
import { Link } from 'react-router-dom';
import { testimonialsData } from '../../../mocks/testimonials';

const TestimonialsSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handlePrevious = () => {
    setCurrentIndex((prev) => (prev === 0 ? testimonialsData.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev === testimonialsData.length - 1 ? 0 : prev + 1));
  };

  const currentTestimonial = testimonialsData[currentIndex];

  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <p className="text-gray-500 text-sm font-sans mb-4 text-center">(CLIENT SUCCESS STORY)</p>
          
          <h2 className="font-montserrat font-bold text-5xl text-gray-900 mb-2 text-center">
            They Saved Me
          </h2>
          <h3 className="font-montserrat font-light text-5xl text-gray-500 mb-8 text-center">
            Thousands in Taxes
          </h3>

          <div className="mb-6">
            <div className="flex gap-1 mb-4 justify-center">
              {[...Array(currentTestimonial.rating)].map((_, i) => (
                <i key={i} className="ri-star-fill text-orange-500 text-xl"></i>
              ))}
            </div>
            <blockquote className="text-gray-700 font-sans text-xl leading-relaxed mb-6 text-center">
              "{currentTestimonial.quote}"
            </blockquote>
            <p className="text-gray-900 font-montserrat font-semibold text-lg text-center">
              — {currentTestimonial.name}, <span className="font-normal text-gray-600">{currentTestimonial.role}</span>
            </p>
          </div>

          <div className="flex items-center gap-4 justify-center">
            <button
              onClick={handlePrevious}
              className="w-12 h-12 flex items-center justify-center border-2 border-gray-300 rounded-full hover:border-orange-500 hover:text-orange-500 transition-colors cursor-pointer"
              aria-label="Previous testimonial"
            >
              <i className="ri-arrow-left-line text-xl"></i>
            </button>
            <button
              onClick={handleNext}
              className="w-12 h-12 flex items-center justify-center bg-black text-white rounded-full hover:bg-orange-500 transition-colors cursor-pointer"
              aria-label="Next testimonial"
            >
              <i className="ri-arrow-right-line text-xl"></i>
            </button>
            <span className="text-gray-500 font-sans text-sm ml-4">
              {currentIndex + 1} / {testimonialsData.length}
            </span>
          </div>

          <div className="mt-8 text-center">
            <Link
              to="/testimonials"
              className="inline-flex items-center gap-2 text-orange-500 font-sans font-semibold hover:gap-3 transition-all cursor-pointer"
            >
              View All Testimonials
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
